import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { safeAnchorHref } from '../../../lib/link';
import { getDataTestId } from '../../../lib/props';
import { cn } from '../../../lib/utils';
import { SpecraBackgroundJobRow } from '../lieutenants/background-job-row';
import { SpecraSectionHeader } from '../lieutenants/section-header';
/** Quiet collection of active background work. Returns `null` (and no ref target) when empty. */ export const SpecraBackgroundJobs = /*#__PURE__*/ React.forwardRef(({ className, getItemProps, getItemTestId, heading, jobs, renderLink, runningCount, viewAllHref, viewAllLabel = /*#__PURE__*/ _jsx(_Fragment, {
    children: "View all →"
}), ...props }, ref)=>{
    if (jobs.length === 0) return null;
    const fallbackViewAllHref = viewAllHref ? safeAnchorHref(viewAllHref) : undefined;
    return /*#__PURE__*/ _jsxs("section", {
        className: cn(className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                action: viewAllHref && renderLink ? renderLink({
                    children: viewAllLabel,
                    className: 'text-[length:var(--fs-ui-eyebrow)] text-muted-foreground hover:text-foreground',
                    href: viewAllHref
                }) : fallbackViewAllHref ? /*#__PURE__*/ _jsx("a", {
                    href: fallbackViewAllHref,
                    className: "text-[length:var(--fs-ui-eyebrow)] text-muted-foreground hover:text-foreground",
                    children: viewAllLabel
                }) : null,
                title: heading ?? (runningCount === undefined ? 'Background jobs' : `Background jobs · ${runningCount} running`)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden rounded-lg border border-border",
                children: jobs.map((job, index)=>{
                    const itemProps = getItemProps?.(job);
                    return /*#__PURE__*/ _createElement(SpecraBackgroundJobRow, {
                        ...itemProps,
                        className: cn(index < jobs.length - 1 && 'border-b border-border', itemProps?.className),
                        "data-item-id": job.id,
                        "data-testid": getItemTestId?.(job) ?? getDataTestId(itemProps),
                        job: job,
                        key: job.id
                    });
                })
            })
        ]
    });
});
SpecraBackgroundJobs.displayName = 'SpecraBackgroundJobs';
/** @deprecated Use SpecraBackgroundJobs. */ export const BackgroundJobs = SpecraBackgroundJobs;
